import { getAuthToken } from '@/assets/js/Authentication'
import HttpRequest from './HttpRequest'

export default class Ac2WebhookLogsProvider extends HttpRequest {
  getWebhookLogs (query) {
    this.setHeader(getAuthToken())
    return this.getByPagination('/ac2/webhook-logs', query)
  }

  manualWebhookLogById (id) {
    this.setHeader(getAuthToken())
    return this.patch(`/ac2/webhook-logs/${id}/manual`)
  }
}
